import CRM from '../../../api/crm';
import * as helpers from '../../components/helpers/Helpers';
import companyType from '../../constants-v2/person/company-type.js';
import disabilityLevel from '../../constants-v2/person/disability-level.js';
import { DEFAULT_FREE_TAX_AMOUNT_VALUE } from '../../constants/company.js';

const getBaseCompany = () => {
  return {
    name: '',
    surname: '',
    nip: '',
    nip_ue: '',
    regon: '',
    phone: '',
    email: '',
    pit_declaration_email: '',
    vat_declaration_email: '',
    address: {},
    pkd: '',
    proportion: '',
    tax_loss_value: 0,
    business_activity_start: '',
    suspension_of_business_activity_from: '',
    suspension_of_business_activity_to: '',
    krs: '',
    register_of_entrepreneurs: '',
    companytype: companyType.JDG,
    tax_office: '',
    official_bank_account: '',
    form_of_accounting: '',
    pit_settlement: '',
    tax_type: '',
    vat_payer: '',
    vat_settlement: '',
    settlement_method: '',
    resignation_of_vat_r: '',
    resignation_from_dismissal: '',
    intracommunitary_transactions: '',
    cash_register: '',
    include_free_tax_amount: true,
    free_tax_amount_value: DEFAULT_FREE_TAX_AMOUNT_VALUE,
    income_previous_year: '',
    basis_for_health_contribution_base: false,
    start_reduction_from: '',
    start_reduction_to: '',
    agrees_to_the_disease_from: '',
    using_preference_zus_from: '',
    using_preference_zus_to: '',
    own_company_from: '',
    own_company_to: '',
    has_maly_zus_full_fp: false,
    right_to_pension: '',
    right_to_retirement: '',
    disability_level: disabilityLevel.NONE_ID,
    using_maly_zus: '',
    preference_zus_civillaw_income: '',
    have_income_from_civillaw_contract: '',
    is_employment_contract: '',
    is_foreign_company: false,
    is_affiliated_entity: false,
    country_code: '',
    is_simplified: 0,
    vat_exemption_basis: null,
    zus_account_number: '',
    companylogo: [],
    partner: [],
    short_name: '',
    bdo: '',
  };
};
const getBaseCrm = () => {
  return {
    status: {},
    client: {
      person: {
        name: '',
        second_name: '',
        surname: '',
        family_name: '',
        phone: '',
        email: '',
        login_email: '',
        correspondence_email: '',
        citizenship: '',
        pesel: '',
        birth_date: null,
        gender: null,
        bankaccounts: [],
        personbankaccount: {
          main_bank_account: {},
        },
        personaddress: {
          residence_address: {},
          registered_address: {},
          correspondence_address: {},
          company_address: {},
          is_simplified: 0,
        },
        company: getBaseCompany(),
        personstatustype: {},
        is_simplified: 0,
        identification_type: '',
        identification_series: '',
        identification_number: '',
        identification_issue_place: '',
        identification_issue_by: '',
        identification_issue_date: '',
        identification_expiration_date: '',
      },
    },
    crmusstaff: [],
    crmzusstaff: [],
    industrytype: {},
    crmformtype: {},
    is_simplified: 0,
    sourcecrm: null,
    sourcecrm_original: null,
  };
};
const baseDocument = {
  document_type: '',
  document_number: '',
  release_date: '',
  expiration_date: '',
};

const state = {
  crm: getBaseCrm(),
  crmList: [],
  statuses: [],
  status: {},
  statusFilter: {},
  lastId: 0,
  dictionary: {
    priceListTypes: [
      { id: 1, label: 'Cena za' },
      { id: 2, label: 'Cena od' },
    ],
    priceListUnits: [],
  },
  crmIds: [],
  actions: [],
  actionDescription: '',
  loading: false,
  config: {
    actions: {
      crm: {},
    },
  },
  citizenships: [
    { value: 1, label: 'Polskie' },
    { value: 2, label: 'Czeskie' },
  ],
  refresh: false,
};

const getters = {
  getStatusLabel(state) {
    return (id) => {
      if (!id) {
        return '';
      }
      let statusObj = state.statuses.filter(function (x) {
        return x.id === id;
      });
      let label = '';
      if (statusObj.length > 0) {
        label = statusObj[0].label;
      }
      return label;
    };
  },
  getCorrespondenceAddress: state => {
    return state.crm.client.person.personaddress.correspondence_address;
  },
  getRegisteredAddress: state => {
    return state.crm.client.person.personaddress.registered_address;
  },
  getResidenceAddress: state => {
    return state.crm.client.person.personaddress.residence_address;
  },
  getCompanyAddress: state => {
    return state.crm.client.person.personaddress.company_address;
  },
  getPersonId: state => {
    return state.crm.client.person.id;
  },
  getBankAccounts: state => {
    return state.crm.client.person.bankaccounts;
  },
  getDefaultAccount: state => {
    if (state.crm.client.person.personbankaccount && state.crm.client.person.personbankaccount.main_bank_account && state.crm.client.person.personbankaccount.main_bank_account.id) {
      return state.crm.client.person.personbankaccount.main_bank_account;
    }
    return {};
  },
};

const actions = {
  index({ commit, state }, url, sortType) {
    // commit('LOADER/setLoading', true, {root: true});
    return new Promise((resolve, reject) => {
      CRM.index(url, sortType).then(response => {
        commit('setCrmList', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        // commit('LOADER/setLoading', false, {root: true});
      });
    });
  },

  fetchAll(
    { commit, state },
    {
      sortType,
      config = {},
    } = {},
  ) {
    return new Promise((resolve, reject) => {
      CRM.index('', sortType, config)
        .then(response => {
          commit('setCrmList', response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  storeCrm({ commit, state }) {
    return new Promise((resolve, reject) => {
      CRM
        .store({
          crm: state.crm,
        })
        .then(response => {
          commit('setCrm', response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCrm({ commit, state }, crmData) {
    commit('LOADER/setLoading', true, { root: true });
    const data = (crmData === null || crmData === undefined) ? state.crm : crmData;
    return new Promise((resolve, reject) => {
      CRM.update({
        crm: data,
        actions: state.config.actions,
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      })
        .finally(() => {
          commit('LOADER/setLoading', false, { root: true });
        });
    });
  },
  updateCrmNative({ commit, state }, crmData) {
    const data = (crmData === null || crmData === undefined) ? state.crm : crmData;
    return new Promise((resolve, reject) => {
      CRM.updateNative({
        crm: data,
        actions: state.config.actions,
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  showCrm({ commit, dispatch, state }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      let statusFilter = state.statusFilter ? state.statusFilter : {};
      CRM.show({ id, status: statusFilter }).then(response => {
        commit('setCrm', response.data);
        commit('setActions', []);
        dispatch('indexActions', response.data.id);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  showCrmNative({ commit, dispatch, state }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      let statusFilter = state.statusFilter ? state.statusFilter : {};
      CRM.showNative({ id, status: statusFilter }).then(response => {
        commit('setCrm', response.data);
        dispatch('indexActions', response.data.id);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  getDictionary({ commit }) {
    return new Promise((resolve, reject) => {
      CRM.getDefaultDictionary().then(response => {
        localStorage.setItem('dictionaryCrm', JSON.stringify(response.data));
        commit('setDictionary', JSON.parse(localStorage.getItem('dictionaryCrm')));
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getNotDefaultDictionary({ commit }, pricelistId) {
    return new Promise((resolve, reject) => {
      CRM.getNotDefaultDictionary(pricelistId).then(response => {
        localStorage.setItem('dictionaryCrm', JSON.stringify(response.data));
        commit('setDictionary', JSON.parse(localStorage.getItem('dictionaryCrm')));
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  setDictionary({ commit }, payload) {
    commit('setDictionary', payload);
  },

  indexCrmIdList({ commit, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      let statusId = state.statusFilter ? state.statusFilter.id : null;
      CRM.indexCrmIdList(statusId).then(response => {
        commit('setCrmIds', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  indexStatuses({ commit }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      CRM.STATUS.index().then(response => {
        commit('setStatuses', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  updateResidenceAddress({ commit }, residence_address) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      commit('setResidenceAddress', residence_address);
      setTimeout(function () {
        commit('LOADER/setLoading', false, { root: true });
        resolve();
      }, 1000);
    });
  },
  updateRegisteredAddress({ commit }, registered_address) {
    commit('LOADER/setLoading', true, { root: true });
    commit('setRegisteredAddress', registered_address);
    setTimeout(function () {
      commit('LOADER/setLoading', false, { root: true });
    }, 1000);
  },
  updateCorrespondenceAddress({ commit }, correspondence_address) {
    commit('LOADER/setLoading', true, { root: true });
    commit('setCorrespondenceAddress', correspondence_address);
    setTimeout(function () {
      commit('LOADER/setLoading', false, { root: true });
    }, 1000);
  },
  updateCompanyAddress({ commit }, company_address) {
    commit('LOADER/setLoading', true, { root: true });
    commit('setCompanyAddress', company_address);
    setTimeout(function () {
      commit('LOADER/setLoading', false, { root: true });
    }, 1000);
  },
  storeAction({ commit }, payload) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      CRM.ACTION.store(payload).then(response => {
        commit('setAction', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  indexActions({ commit }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      CRM.ACTION.index(id).then(response => {
        commit('setActions', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  setCrm({ commit }, status) {
    commit('setCrm', status);
  },
  setStatus({ commit }, status) {
    commit('setStatus', status);
  },
  setStatusFilter({ commit }, status) {
    commit('setStatusFilter', status);
  },
  updateStatus({ commit }, payload) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      CRM.STATUS.update(payload).then(response => {
        commit('setStatusAfterSave', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  clearStatus({ commit }) {
    commit('clearStatus');
  },
  clearCrm({ commit }) {
    commit('clearCrm');
  },
  clearCompany({ commit }) {
    commit('clearCompany');
  },
  clearCrmIdList({ commit }) {
    commit('clearCrmIdList');
  },
  clearAddresses({ commit }) {
    commit('setResidenceAddress', {});
    commit('setRegisteredAddress', {});
    commit('setCorrespondenceAddress', {});
  },
  getVersions({ commit }, original) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      CRM.getVersions(original).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  setPersonStatus({ commit }, status) {
    commit('setPersonStatus', status);
  },
  setConfiguration({ commit }, payload) {
    commit('setConfiguration', payload);
  },
  setCrmSimplified({ commit }) {
    commit('setCrmSimplified');
  },
  impersonate({ commit }, { crmId, asIs }) {
    commit('LOADER/setLoading', true, { root: true });

    return new Promise((resolve, reject) => {
      CRM.ACTION.impersonate(crmId, asIs)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
        .finally(() => commit('LOADER/setLoading', false, { root: true }));
    });
  },
  activate({ commit }, { crm_id, crm_original }) {
    return new Promise((resolve, reject) => {
      CRM.activate({ crm_id, crm_original })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  deactivate({ commit }, { crm_id, crm_original }) {
    return new Promise((resolve, reject) => {
      CRM.deactivate({ crm_id, crm_original })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  recharge({ commit }, { change, currency }) {
    return CRM.recharge({ change, currency });
  },
  getMainBroker() {
    return new Promise((resolve, reject) => {
      CRM.getMainBroker().then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  refresh({ commit }, payload) {
    commit('refresh', payload);
  },
  setCorrespondenceAddress({ commit }, payload) {
    commit('setCorrespondenceAddress', payload);
  },
  setCompanyAddress({ commit }, payload) {
    commit('setCompanyAddress', payload);
  },
  setCompanyData({ commit }, payload) {
    commit('setCompanyData', payload);
  },
  setCrmFormType({ commit }, payload) {
    commit('setCrmFormType', payload);
  },
  getPublicCrmData({ commit }, identity) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      CRM.getPublicCrmData(identity)
        .then(response => resolve(response))
        .catch(error => reject(error))
        .finally(() => commit('LOADER/setLoading', false, { root: true }));
    });
  },
  setPriceListUnits({ commit }, payload) {
    commit('setPriceListUnits', payload);
  },
};

const mutations = {
  updateCrm(state, { key, value }) {
    state.crm[key] = value;
  },
  setPriceListUnits(state, data) {
    state.dictionary.priceListUnits = data.map(el => {
      return {
        ...el,
        label: el.name,
      };
    });
  },
  updateCompany(state, { key, value }) {
    state.crm.client.person.company = {
      ...state.crm.client.person.company,
      [key]: value,
    };
  },
  updateClient(state, { key, value }) {
    state.crm.client[key] = value;
  },
  updatePerson(state, { key, value }) {
    state.crm.client.person = {
      ...state.crm.client.person,
      [key]: value,
    };
  },
  setCrmIds(state, crmIdList) {
    state.crmIds = crmIdList;
  },
  setCrmList(state, crmList) {
    state.crmList = crmList;
  },
  setStatuses(state, statuses) {
    state.statuses = typeof statuses === 'object' ? Object.values(statuses) : statuses;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setCrm(state, crm) {
    if (crm?.client?.person && crm.client.person.company == null) {
      crm.client.person.company = getBaseCompany();
    }
    state.crm = crm;
  },
  setStatusFilter(state, status) {
    state.statusFilter = status;
  },
  setStatusAfterSave(state, status) {
    let statusObj = state.statuses.filter(function (x) {
      return x.id === parseInt(status.status);
    });
    state.status = statusObj[0];
    state.crm.status = statusObj[0];
  },
  setActionDescription(state, description) {
    state.actionDescription = description;
  },
  setAction(state, action) {
    let status = helpers.methods.getStatusIconAndColor(action.status);
    state.actions.unshift({
      id: action.id,
      color: status.color,
      icon: status.icon,
      title: action.label,
      desc: action.message,
      time: action.created_at,
      additional_date: action.additional_date,
    });
    state.actionDescription = '';
  },
  setActions(state, actions) {
    let list = [];
    for (let key in actions) {
      if (actions.hasOwnProperty(key) && Number.isInteger(parseInt(key))) {
        let status = helpers.methods.getStatusIconAndColor(actions[key].status);
        list.push({
          id: actions[key].id,
          color: status.color,
          icon: status.icon,
          title: actions[key].label,
          desc: actions[key].message,
          time: actions[key].created_at,
          additional_date: actions[key].additional_date,
        });
      }
    }
    state.actions = list;
  },
  setLoginEmail(state, eamil) {
    state.crm.client.person.login_email = eamil;
  },
  setCompanyPhone(state, phone) {
    state.crm.client.person.company.phone = phone;
  },
  setCompanyEmail(state, email) {
    state.crm.client.person.company.email = email;
  },
  setCompanyBusinessActivityStart(state, business_activity_start) {
    state.crm.client.person.company.business_activity_start = business_activity_start;
  },
  setCompanySuspensionOfBusinessActivityFrom(state, suspension_of_business_activity_from) {
    state.crm.client.person.company.suspension_of_business_activity_from = suspension_of_business_activity_from;
  },
  setCompanySuspensionOfBusinessActivityTo(state, suspension_of_business_activity_to) {
    state.crm.client.person.company.suspension_of_business_activity_to = suspension_of_business_activity_to;
  },
  setCompanyPkd(state, pkd) {
    state.crm.client.person.company.pkd = pkd;
  },
  setCompanyKrs(state, krs) {
    state.crm.client.person.company.krs = krs;
  },
  setCompanyBdo(state, bdo) {
    state.crm.client.person.company.bdo = bdo;
  },
  setCompanyRegisterOfEntreoreneurs(state, register_of_entrepreneurs) {
    state.crm.client.person.company.register_of_entrepreneurs = register_of_entrepreneurs;
  },
  setCompanyType(state, companytype) {
    state.crm.client.person.company.companytype = companytype;
  },
  setCompanyOfficialBankAccount(state, official_bank_account) {
    state.crm.client.person.company.official_bank_account = official_bank_account;
  },
  setCompanyTaxOffice(state, tax_office) {
    state.crm.client.person.company.tax_office = tax_office;
  },
  setCompanyName(state, name) {
    state.crm.client.person.company.name = name;
  },
  setCompanyShortName(state, short_name) {
    state.crm.client.person.company.short_name = short_name;
  },
  setCompanyFormOfAccounting(state, form_of_accounting) {
    state.crm.client.person.company.form_of_accounting = form_of_accounting;
  },
  setCompanyPitSettlement(state, pit_settlement) {
    state.crm.client.person.company.pit_settlement = pit_settlement;
  },
  setCompanyTaxType(state, tax_type) {
    state.crm.client.person.company.tax_type = tax_type;
  },
  setCompanyVatPayer(state, vat_payer) {
    state.crm.client.person.company.vat_payer = vat_payer;
  },
  setCompanyVatSettlement(state, vat_settlement) {
    state.crm.client.person.company.vat_settlement = vat_settlement;
  },
  setCompanySettlementMethod(state, settlement_method) {
    state.crm.client.person.company.settlement_method = settlement_method;
  },
  setCompanyResignationFromDismissal(state, resignation_from_dismissal) {
    state.crm.client.person.company.resignation_from_dismissal = resignation_from_dismissal;
  },
  setCompanyStartReductionFrom(state, start_reduction_from) {
    state.crm.client.person.company.start_reduction_from = start_reduction_from;
  },
  setCompanyStartReductionTo(state, start_reduction_to) {
    state.crm.client.person.company.start_reduction_to = start_reduction_to;
  },
  setCompanyAgreesToTheDiseaseFrom(state, agrees_to_the_disease_from) {
    state.crm.client.person.company.agrees_to_the_disease_from = agrees_to_the_disease_from;
  },
  setCompanyUsingPreferenceZusFrom(state, using_preference_zus_from) {
    state.crm.client.person.company.using_preference_zus_from = using_preference_zus_from;
  },
  setCompanyUsingPreferenceZusTo(state, using_preference_zus_to) {
    state.crm.client.person.company.using_preference_zus_to = using_preference_zus_to;
  },
  setCompanyZusAccountNumber(state, zus_account_number) {
    state.crm.client.person.company.zus_account_number = zus_account_number;
  },
  setCompanyDisabilityLevel(state, disability_level) {
    state.crm.client.person.company.disability_level = disability_level;
  },
  setCompanyUsingMalyZus(state, using_maly_zus) {
    state.crm.client.person.company.using_maly_zus = using_maly_zus;
  },
  setCompanyProportion(state, proportion) {
    state.crm.client.person.company.proportion = proportion;
  },
  setCompanyTaxLossValue(state, tax_loss_value) {
    state.crm.client.person.company.tax_loss_value = tax_loss_value;
  },
  setNip(state, nip) {
    state.crm.client.person.company.nip = nip;
  },
  setNipUE(state, nip_ue) {
    state.crm.client.person.company.nip_ue = nip_ue;
  },
  setRegon(state, regon) {
    state.crm.client.person.company.regon = regon;
  },
  setIsForeignCompany(state, is_foreign_company) {
    state.crm.client.person.company.is_foreign_company = is_foreign_company;
  },
  setIsAffiliatedEntity(state, is_affiliated_entity) {
    state.crm.client.person.company.is_affiliated_entity = is_affiliated_entity;
  },
  setCountryCode(state, country_code) {
    state.crm.client.person.company.country_code = (country_code || '').toUpperCase();
  },
  setVatExemptionBasis(state, value) {
    state.crm.client.person.company.vat_exemption_basis = value;
  },
  setCompanyLogoUrl(state, logo) {

    let logos = state.crm.client.person.company.companylogo;

    let invoiceLogo = logos.find(({ module }) => module === 'invoice');
    if (invoiceLogo === undefined) {
      logos.push({ module: 'invoice', _logo_url: logo });
    } else {
      invoiceLogo._logo_url = logo;
    }
  },
  setCompanyLogoFilename(state, logo) {
    let logos = state.crm.client.person.company.companylogo;
    let invoiceLogo = logos.find(({ module }) => module === 'invoice');
    if (invoiceLogo === undefined) {
      logos.push({ module: 'invoice', logo_filename: logo });
    } else {
      if (logo === null) {
        logos.splice(logos.findIndex(item => item.module === 'invoice'), 1);
      } else {
        invoiceLogo.logo_filename = logo;
      }
    }
  },
  setCompanyLogoSrc(state, logo) {
    let logos = state.crm.client.person.company.companylogo;
    let invoiceLogo = logos.find(({ module }) => module === 'invoice');
    if (invoiceLogo === undefined) {
      logos.push({ module: 'invoice', _logo_src: logo });
    } else {
      invoiceLogo._logo_src = logo;
    }
  },
  setClientName(state, name) {
    state.crm.client.person.name = name;
  },
  setSecondName(state, secondName) {
    state.crm.client.person.second_name = secondName;
  },
  setSurname(state, surname) {
    state.crm.client.person.surname = surname;
  },
  setFamilyName(state, familyName) {
    state.crm.client.person.family_name = familyName;
  },
  setPhone(state, phone) {
    state.crm.client.person.phone = phone;
  },
  setEmail(state, email) {
    state.crm.client.person.email = email;
  },
  setCorrespondenceEmail(state, correspondence_email) {
    state.crm.client.person.correspondence_email = correspondence_email;
  },
  setCitizenship(state, citizenship) {
    state.crm.client.person.citizenship = citizenship;
  },
  setPesel(state, pesel) {
    state.crm.client.person.pesel = pesel;
  },
  setBirthDate(state, birthDate) {
    state.crm.client.person.birth_date = birthDate;
  },
  setGender(state, gender) {
    state.crm.client.person.gender = gender;
  },
  clearStatus(state) {
    state.status = {};
  },
  //DOCUMENT
  setDocumentType(state, type) {
    state.document.document_type = type;
  },
  setDocumentNumber(state, number) {
    state.document.document_number = number;
  },
  setReleaseDate(state, date) {
    state.document.release_date = date;
  },
  setExpirationDate(state, date) {
    state.document.expiration_date = date;
  },
  clearDocument(state) {
    state.document = { ...baseDocument };
  },
  clearCrm(state) {
    state.crm = getBaseCrm();
  },
  clearCompany(state) {
    state.crm.client.person.company = getBaseCompany();
  },
  clearCrmIdList(state) {
    state.crmIds = [];
  },
  setResidenceAddress(state, residence_address) {
    state.crm.client.person.personaddress.residence_address = residence_address;
  },
  setRegisteredAddress(state, registered_address) {
    state.crm.client.person.personaddress.registered_address = registered_address;
  },
  setCorrespondenceAddress(state, correspondence_address) {
    state.crm.client.person.personaddress.correspondence_address = correspondence_address;
  },
  setCompanyAddress(state, company_address) {
    state.crm.client.person.personaddress.company_address = company_address;
  },

  // BANK ACCOUNTS
  addCompanyBankAccount(state, account) {
    state.crm.client.person.bankaccounts.push(account);
  },
  setDefaultAccount(state, account) {
    if (!state.crm.client.person.personbankaccount) {
      state.crm.client.person.personbankaccount = {
        id: 0,
      };
    }
    state.crm.client.person.personbankaccount.main_bank_account = account;
  },

  setDictionary(state, dictionary) {
    let tmpServices = [];
    dictionary.forEach((item) => {
      let tmpItem = {
        id: item.id,
        label: item.name,
      };
      tmpServices.push(tmpItem);
    });
    state.dictionary.services = tmpServices;
  },
  setPersonStatus(state, status) {
    state.crm.client.person.personstatustype = status;
  },
  setIndustryType(state, industry_type) {
    state.crm.industrytype = industry_type;
  },
  setCrmFormType(state, crm_form_type) {
    state.crm.crmformtype = crm_form_type;
  },
  setConfiguration(state, configuration) {
    state.config.actions.crm = configuration;
  },
  setCrmUsStaff(state, staffs) {
    state.crm.crmusstaff = staffs;
  },
  setCrmZusStaff(state, staffs) {
    state.crm.crmzusstaff = staffs;
  },
  //Options
  refresh(state, payload) {
    state.refresh = payload;
  },
  setCrmSimplified(state) {
    state.crm.is_simplified = 1;
    state.crm.client.person.is_simplified = 1;
    state.crm.client.person.company.is_simplified = 1;
    state.crm.client.person.personaddress.is_simplified = 1;
  },
  setCompanyData(state, company) {
    state.crm.client.person.company = {
      ...state.crm.client.person.company,
      ...company,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
